export const HOTEL_GALLERY_TIMER = 400;
